import React from 'react';
import {
  useQuery,
  useMutation,
  useParameterizedQuery
} from 'react-fetching-library';
import Page from '../../components/Page';
import InfoIcon from '@mui/icons-material/Info';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SubdirectoryArrowRight from '@mui/icons-material/SubdirectoryArrowRight';
import Done from '@mui/icons-material/Done';
import Add from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Card,
  CardContent,
  Stack,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Button,
  Paper,
  TableContainer,
  Typography,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  IconButton,
  Box
} from '@mui/material';
import {
  downloadOrganizationalDocumentFileAction,
  getManagerPeriodsAction,
  getAllPeriodsAction,
  getOrganizationalDocumentSections,
  updateOrganizationalDocumentSectionAction,
  createOrganizationalDocumentSectionAction,
  destroyOrganizationalDocumentSectionFileAction,
  updateOrganizationalDocumentSubSectionAction,
  destroyOrganizationalDocumentSubSectionFileAction,
  downloadOrganizationalDocumentSubFileAction,
  createOrganizationalDocumentSubSectionAction,
  deleteOrganizationalDocumentSubSectionAction
} from '../../services/request';
import toast from 'react-hot-toast';
import DocumentForm from './organizational-document-sections/DocumentForm';
import PDFPreviewModal from '../employee/applications/applicationForm/tabs/documents/PDFPreviewModal';
import { useManager } from '../../pages/Manager';
import SectionForm from './organizational-document-sections/SectionForm';
import { ConfirmDialog } from '../../components/ConfirmDialog';
import { COORDINATOR, MANAGER, MANAGERASSIST } from '../employee/applications/functions';

export default function OrganizationalDocumentSections({ officeView = false }) {
  const { choices, application } = useManager();
  const { loading, payload, error } = useQuery(officeView ? getAllPeriodsAction() : getManagerPeriodsAction(true, application?.id));
  const { mutate, loading: mutateLoading } = useMutation(getOrganizationalDocumentSections);
  const downloadOrgDocFileQuery = useParameterizedQuery(downloadOrganizationalDocumentFileAction);
  const downloadOrgDocSubFileQuery = useParameterizedQuery(downloadOrganizationalDocumentSubFileAction);
  const uploadFileMutation = useMutation(updateOrganizationalDocumentSectionAction);
  const uploadSubFileMutation = useMutation(updateOrganizationalDocumentSubSectionAction);
  const createSectionMutation = useMutation(createOrganizationalDocumentSectionAction);
  const createSubSectionMutation = useMutation(createOrganizationalDocumentSubSectionAction);
  const destroyFileMutation = useMutation(destroyOrganizationalDocumentSectionFileAction);
  const destroySubFileMutation = useMutation(destroyOrganizationalDocumentSubSectionFileAction);
  const deleteSubSectionMutation = useMutation(deleteOrganizationalDocumentSubSectionAction);
  const [sectionIdToDestroyFile, setSectionIdToDestroyFile] = React.useState(false);
  const [weekPeriods, setWeekPeriods] = React.useState([]);
  const [weekPeriod, setWeekPeriod] = React.useState(null);
  const [sections, setSections] = React.useState([]);
  const [selectedSectionId, setSelectedSectionId] = React.useState(false);
  const [selectedSectionIsSubSection, setSelectedSectionIsSubsection] = React.useState(false);
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const [openAddDocument, setOpenAddDocument] = React.useState(false);
  const [selectedParentSectionId, setSelectedParentSectionId] = React.useState(false);
  const [openAddSection, setOpenAddSection] = React.useState(false);
  const [resort, setResort] = React.useState(null);
  const [officeOtherCategories, setOfficeOtherCategories] = React.useState([]);

  React.useEffect(() => {
    if (!error && !loading) {
      if (officeView) {
        setWeekPeriods(payload.periods);
        setOfficeOtherCategories(payload.other_categories);
      } else {
        setWeekPeriods(payload);
      }
    }
    if (error) {
      toast.error('Wystąpił błąd');
    }
  }, [loading]);

  const handleChangePeriod = event => {
    const choosenPeriod = weekPeriods.filter(period => period.name === event.target.value)[0];
    setWeekPeriod(choosenPeriod);
    setSections([]);
    setResort(null);
  };

  const handleShowSections = async () => {
    const { payload, error, loading } = await mutate({ period: weekPeriod, resort });
    if (!error && !loading) {
      console.log(payload);
      setSections(payload);
    } else {
      toast.error('Nie udało się pobrać dokumentów');
    }
  };

  const handleUpload = (sectionId, isSubsection) => {
    setSelectedSectionId(sectionId);
    setSelectedSectionIsSubsection(isSubsection);
    setOpenAddDocument(true);
  };

  const updateSectionTree = (sections, updated) => sections.map(section => {
    // 1️⃣ sekcja główna
    if (section.id === updated.id) {
      return updated;
    }

    if (!section.sub_sections) {
      return section;
    }

    return {
      ...section,
      sub_sections: section.sub_sections.map(sub => {
        // 2️⃣ sub-sekcja
        if (sub.id === updated.id) {
          return updated;
        }

        if (!sub.sub_sections) {
          return sub;
        }

        // 3️⃣ sub-sub-sekcja
        return {
          ...sub,
          sub_sections: sub.sub_sections.map(s => s.id === updated.id ? updated : s
          )
        };
      })
    };
  });


  const uploadFileCallback = async (sectionId, formData) => {
    const mutation = selectedSectionIsSubSection
      ? uploadSubFileMutation
      : uploadFileMutation;

    const { error, payload } = await mutation.mutate(formData, sectionId);

    if (error) {
      toast.error('Nie udało się wczytać pliku');

      return false;
    }

    setSections(prev => updateSectionTree(prev, payload));

    toast.success('Poprawnie wczytano plik');

    return true;
  };

  const handleDestroyFile = async () => {
    const mutation = sectionIdToDestroyFile.isSubsection ? destroySubFileMutation : destroyFileMutation;
    const { error, loading, payload } = await mutation.mutate(sectionIdToDestroyFile.sectionId);
    if (error) {
      toast.error('Nie udało się wczytać pliku');

      return false;
    }
    setSections(prev => updateSectionTree(prev, payload));

    toast.success('Pomyślnie usunięto plik z wybranej sekcji');

    return true;
  };

  const handleDownload = async (row, preview = false, isSubsection = false) => {
    const dynamicQuery = isSubsection ? downloadOrgDocSubFileQuery : downloadOrgDocFileQuery;
    const { payload, error, loading } = await dynamicQuery.query(row.id);

    if (!error) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${row.file_name}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };

  const handleAddNewSection = parentSectionId => {
    setSelectedParentSectionId(parentSectionId);
    setOpenAddSection(true);
  };

  const handleAddNewSubSection = async sectionId => {
    const { error, loading, payload } =
      await createSubSectionMutation.mutate({ section_id: sectionId });

    if (!error && !loading) {
      setSections(prev => prev.map(section => section.id === payload.main_section
        ? {
          ...section,
          sub_sections: section.sub_sections.map(subSection => subSection.id === payload.parent_section
            ? {
              ...subSection,
              sub_sections: [
                ...(subSection.sub_sections || []),
                payload
              ]
            }
            : subSection
          )
        }
        : section
      )
      );
    } else {
      toast.error('Nie udało się dodać nowej sekcji');
    }
  };

  const handleDeleteNewSubSection = async sectionId => {
    const { error, loading, payload } =
      await deleteSubSectionMutation.mutate(sectionId);

    if (!error && !loading) {
      setSections(prev => prev.map(section => ({
        ...section,
        sub_sections: section.sub_sections.map(subSection => ({
          ...subSection,
          sub_sections: (subSection.sub_sections || []).filter(
            ss => ss.id !== sectionId
          )
        }))
      }))
      );
    } else {
      toast.error('Nie udało się usunąć subsekcji');
    }
  };

  const addNewSectionCallback = async data => {
    const { error, loading, payload } = await createSectionMutation.mutate(data);
    if (!error && !loading) {
      setSections(prev => prev.map(ps => ps.id == payload.parent_section ? { ...ps, sub_sections: [...ps.sub_sections, payload] } : ps));
    } else {
      toast.error('Nie udało się dodać nowej sekcji');
    }
  };

  const handleDisabled = () => {
    if (application && application.periods_type == 'zielone_szkoly') {
      if (!weekPeriod || !resort || mutateLoading) {
        return true;
      }
    } else if (!weekPeriod || mutateLoading) {
      return true;
    }

    return false;
  };

  const StatusIcon = ({ icon, color, text, tooltip }) => (
    <Tooltip title={tooltip}>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {React.cloneElement(icon, { fontSize: 'small', color })}
        <Typography variant="caption" color={color}>{text}</Typography>
      </Stack>
    </Tooltip>
  );

  const renderStatus = section => {
    if (section.file) {
      return <StatusIcon icon={<Done />} color="primary" text="Dokument wysłany" tooltip="Dokument został wysłany do biura." />;
    }

    return <StatusIcon icon={<InfoIcon />} color="info" text="Oczekuje na przesłanie" tooltip="Należy wysłać dokument przyciskiem obok." />;
  };

  const renderActions = (section, isSubsection) => {
    if (!section.file) {
      return <ActionButton title="Wgraj Plik..." icon={<UploadFileIcon color="primary" />} onClick={() => handleUpload(section.id, isSubsection)} />;
    }

    return (
      <Stack direction="row">
        {section.can_preview && <ActionButton title="Pokaż Plik" icon={<RemoveRedEyeIcon color="primary" />} onClick={() => handleDownload(section, true, isSubsection)} />}
        <ActionButton title="Pobierz Plik" icon={<FileDownloadIcon color="info" />} onClick={() => handleDownload(section, false, isSubsection)} />
        {officeView && <ActionButton title="Usuń Plik" icon={<DeleteIcon color="error" />} onClick={() => setSectionIdToDestroyFile({ sectionId: section.id, isSubsection })} />}
      </Stack>
    );
  };

  const ActionButton = ({ title, icon, onClick }) => (
    <Tooltip title={title}>
      <IconButton onClick={onClick}>{icon}</IconButton>
    </Tooltip>
  );

  const DocumentRow = ({ section, level = 0, isSubsection = false }) => (
    <>
      <TableRow>
        <TableCell>
          <Box sx={{ pl: level * 3, display: 'flex', alignItems: 'center', gap: 1 }}>
            {level > 0 && <SubdirectoryArrowRight fontSize="small" />}
            <Typography variant="caption">
              {section.name}
            </Typography>
            {!isSubsection ? <Tooltip title="Dodaj nową podsekcję">
              <IconButton variant="contained" color="primary" onClick={() => handleAddNewSubSection(section.id)}><Add /></IconButton>
            </Tooltip> : <Tooltip title="Usuń podsekcję">
              <IconButton variant="contained" color="error" onClick={() => handleDeleteNewSubSection(section.id)}><DeleteIcon /></IconButton>
            </Tooltip>}
          </Box>
        </TableCell>

        <TableCell>
          <Typography variant="caption">
            {section.file_added_by_display}
          </Typography>
        </TableCell>

        <TableCell>{renderStatus(section)}</TableCell>
        <TableCell>{renderActions(section, isSubsection)}</TableCell>
      </TableRow>

      {section.sub_sections?.map(sub => (
        <DocumentRow
          key={sub.id}
          section={sub}
          level={level + 1}
          isSubsection={true}
        />
      ))}
    </>
  );

  if (!application && !officeView) {
    return null;
  }

  if (!officeView && ![MANAGER, COORDINATOR, MANAGERASSIST].includes(application.function_type)) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h2" color="error" align="center">Ta aplikacja nie ma dostępu do tej zakładki</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Page title="Dokumenty Organizacyjne">
      <Card>
        <CardContent>
          <Stack justifyContent="center" spacing={3}>
            <FormControl sx={{ minWidth: ' 160px' }}>
              <InputLabel variant="standard" htmlFor="uncontrolled-native">
                  Wybierz termin
              </InputLabel>
              <Select
                placeholder="Wybierz termin"
                variant="standard"
                labelId="periods"
                value={weekPeriod?.nr}
                defaultValue={null}
                label="Terminy"
                onChange={e => handleChangePeriod(e)}
              >
                {weekPeriods &&
                    weekPeriods.map((obj, key) => (
                      <MenuItem key={key} value={obj.name}>
                        {obj.name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
            {!officeView
            // Widok dla kadry
              ? application.periods_type == 'zielone_szkoly' && application.resort_for_agreement &&
             <FormControl sx={{ minWidth: ' 160px' }}>
               <InputLabel variant="standard" htmlFor="uncontrolled-native">
                  Wybierz ośrodek
               </InputLabel>
               <Select
                 placeholder="Wybierz ośrodek"
                 variant="standard"
                 labelId="resorts"
                 value={resort}
                 defaultValue={null}
                 label="Ośrodki"
                 onChange={e => setResort(e.target.value)}
               >
                 {application.resort_for_agreement == 1 ? <MenuItem value={1}>
                      Ośrodek Sun Sport w Mrówkach
                 </MenuItem>
                   : <MenuItem value={2}>
                      Ośrodek Michasiówka w Giewartowie
                   </MenuItem>}
               </Select>
             </FormControl>
             // Widok dla biura
              : weekPeriod?.name.includes('Tydzień') ? <FormControl sx={{ minWidth: ' 160px' }}>
                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                Wybierz ośrodek
                </InputLabel>
                <Select
                  placeholder="Wybierz ośrodek"
                  variant="standard"
                  labelId="resorts"
                  value={resort}
                  defaultValue={null}
                  label="Ośrodki"
                  onChange={e => setResort(e.target.value)}
                >
                  <MenuItem value={1}>
                    Ośrodek Sun Sport w Mrówkach
                  </MenuItem>
                  <MenuItem value={2}>
                    Ośrodek Michasiówka w Giewartowie
                  </MenuItem>
                </Select>
              </FormControl> : null }
            <Button variant="contained" color="primary" disabled={handleDisabled()} onClick={handleShowSections}>
             Pokaż dokumenty
            </Button>
          </Stack>
        </CardContent>
      </Card>

      {sections.length > 0 && sections.map((ps, key) => (
        <TableContainer component={Paper} sx={{ mb: 3 }} key={key}>
          <Typography color="green" sx={{ p: 2 }}>{ps.name} {ps.name == 'Inne' && <Tooltip title="Dodaj nową sekcję">
            <IconButton variant="contained" color="primary" onClick={() => handleAddNewSection(ps.id)}><Add /></IconButton>
          </Tooltip>}
          </Typography>
          <Divider flexItem />
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><b>Nazwa dokumentu</b></TableCell>
                <TableCell><b>Dodano przez</b></TableCell>
                <TableCell><b>Status</b></TableCell>
                <TableCell><b>Akcje</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ps.sub_sections.map((section, key) => <DocumentRow key={key} section={section} />)}
            </TableBody>
          </Table>
          <Divider flexItem />
        </TableContainer>
      ))}
      <DocumentForm open={openAddDocument} handleClose={() => setOpenAddDocument(false)} sectionId={selectedSectionId} uploadFileCallback={uploadFileCallback} />
      {openAddSection && <SectionForm
        open={openAddSection}
        handleClose={() => setOpenAddSection(false)}
        parentSectionId={selectedParentSectionId}
        addNewSectionCallback={addNewSectionCallback}
        choices={officeView ? officeOtherCategories : choices} />}
      {previewUrl !== null ? <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> : null}
      <ConfirmDialog
        title="Usuń plik"
        open={sectionIdToDestroyFile}
        setOpen={setSectionIdToDestroyFile}
        onConfirm={handleDestroyFile}
      >
        Czy na pewno chcesz usunąć ten plik?
      </ConfirmDialog>
    </Page>
  );
}
